import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const DashboardEImpact = (
    {
        link, 
        widthDashboard = "100%",
        heightDashboard = "100%",
        sidebar,
        setHideBar
    }) => {

    
    let cachedToken = null;
    let tokenExpiry = null;

    const DEFAULT_TOKEN_EXPIRY_MS = 24 * 60 * 60 * 1000;

    const [dashboardToken, setDashboardToken] = useState(null);

    const getServiceToken = async () => {
        const now = Date.now();

        if (cachedToken && tokenExpiry && now < tokenExpiry) {
            return cachedToken;
        }

        const response = await fetch('https://api.eimpactv3.com/trustedLink/getAccess', {
            method: 'POST',
            headers: { 
                "Content-Type": "application/json",
                "User-Agent": "insomnia/2023.5.8"
            },
            body: JSON.stringify({
            secret: "wHT9BBk3",
            domain: "trustedtest",
            }),
            cache: 'no-store',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch service token');
        }

        const data = await response.json();
        const token = data.token;

        cachedToken = token;
        tokenExpiry = data.expiresAt 
            ? new Date(data.expiresAt).getTime() 
            : now + DEFAULT_TOKEN_EXPIRY_MS;

        setDashboardToken(token);
        return;
    }

    useEffect(() => {
       getServiceToken();
    }, [link, getServiceToken])

    useEffect(() => {
        if(window.innerWidth > 767){
            if(sidebar === "HIDDEN") {
                setHideBar(sidebar);
            }else if(sidebar === "ALWAYS OPEN") {
                setHideBar(sidebar);
            }else if(sidebar === "CLOSED") {
                setHideBar(true);
            }else{
                setHideBar(null);
            }
        }
    }, [sidebar, setHideBar]);


    return (
        <Row className="justify-content-md-center pt-0" style={{height: "100%"}}>
            <Col xs={12} className="d-none d-sm-block eimpact_container p-0" style={{ position: "relative"}}>
                {
                    dashboardToken &&
                    <div
                        className="eImpact"
                    >
                        <iframe
                            src={`${link}?secret=${dashboardToken}`}
                            width={widthDashboard}
                            height={heightDashboard}
                            style={{ border: 'none' }}
                            title="Embedded Dashboard"
                        />
                    </div>
                }
                <div className="footer-gradient"></div>
            </Col>
        </Row>
    )
}

export default DashboardEImpact;